import { render, staticRenderFns } from "./ZhuHuiRenYuan.vue?vue&type=template&id=1595342e&scoped=true&"
import script from "./ZhuHuiRenYuan.vue?vue&type=script&lang=js&"
export * from "./ZhuHuiRenYuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595342e",
  null
  
)

export default component.exports